import {
  BLOWER_PICKER_OPTIONS,
  excludedBlowerPickerIdForDwelling,
  FURNACE_FUEL_OPTIONS
} from './component-catalog';
import { BlowerDwelling } from './component-catalog-types';
import { fuelActionForSide } from './composition-side';
import {
  arePicksEmpty,
  compositionAwaitsFuel,
  EMPTY_COMPOSITION_PICKS,
  isCompositionPickReachable
} from './system-composition';
import {
  BlowerComponentId,
  ComponentPickerOption,
  CompositionIndex,
  CompositionPicks,
  CompositionSide,
  FurnaceFuel,
  FurnaceFuelOption
} from './system-composition-types';

export {
  BLOWER_PICKER_OPTIONS,
  COIL_PICKER_OPTIONS,
  FURNACE_FUEL_OPTIONS,
  OUTDOOR_PICKER_OPTIONS,
  PACKAGED_COOLING_PICKER_OPTIONS,
  PACKAGED_HEATING_PICKER_OPTIONS
} from './component-catalog';

export const visiblePickerOptions = <T extends string>(
  options: ComponentPickerOption<T>[],
  selectedId: T | null
): ComponentPickerOption<T>[] =>
  options.filter(
    (option) => !option.hiddenFromOffer || option.id === selectedId
  );

export const blowerOptionsForDwelling = (
  dwelling: BlowerDwelling,
  selectedBlower: BlowerComponentId | null,
  selectedFuel: FurnaceFuel | null = null
): ComponentPickerOption<BlowerComponentId>[] => {
  const excluded = excludedBlowerPickerIdForDwelling(dwelling, selectedFuel);
  return visiblePickerOptions(
    BLOWER_PICKER_OPTIONS.filter(
      (option) => option.id !== excluded || option.id === selectedBlower
    ),
    selectedBlower
  );
};

// The fuel row of one picker column offers only the fuels some catalog type
// on that side can run on (judged from an empty composition, so the offer
// never shrinks as picks narrow — reachability disables those instead). A
// selected fuel always stays visible so a restore can never hide its pill.
export const fuelOptionsForSide = (
  index: CompositionIndex,
  side: CompositionSide,
  selectedFuel: FurnaceFuel | null
): FurnaceFuelOption[] =>
  FURNACE_FUEL_OPTIONS.filter(
    (fuel) =>
      fuel.value === selectedFuel ||
      isCompositionPickReachable(
        EMPTY_COMPOSITION_PICKS,
        fuelActionForSide(side, fuel.value),
        index
      )
  );

export const wantPickerHint = (picks: CompositionPicks): string => {
  if (arePicksEmpty(picks)) {
    return "Pick the components you want and we'll match the exact system type.";
  }
  if (compositionAwaitsFuel(picks)) {
    return 'Choose a fuel type to complete this system.';
  }
  return 'Keep adding or adjusting components to complete a system.';
};
